import { PageLocatorMap } from '../types/PageLocatorMap';

export const applicantSuccessPage = {
  footer: {
    root: 'applicant-success-page.footer.root',
  },
  form: {
    h1: 'applicant-success-page.form.h1',
    h2: 'applicant-success-page.form.h2',
    root: 'applicant-success-page.form.root',
    submitButton: 'applicant-success-page.form.submit-button',
  },
  header: {
    drawerButton: 'applicant-success-page.header.drawer-button',
    root: 'applicant-success-page.header.root',
  },
  progress: {
    root: 'applicant-success-page.progress.root',
  },
} as const satisfies PageLocatorMap;
